const schema = () => ({
  type: 'object',
  required: ['title', 'category_id', 'shop_id', 'amount', 'start_date', 'end_date'],
  properties: {
    title: {
      type: 'string',
      title: 'عنوان بن',
    },
    // category_id: {
    //   type: 'string',
    //   title: 'گروه کاربران',
    // },
    shop_id: {
      type: 'string',
      title: 'انتخاب فروشگاه',
    },
    amount: {
      type: 'number',
      title: 'مبلغ بن',
    },
    start_date: {
      type: 'string',
      title: 'تاریخ شروع بن',
    },
    end_date: {
      type: 'string',
      title: 'تاریخ انقضا بن',
    },
    description: {
      type: 'string',
      title: 'توضیحات',
    },
  },
});

export default schema;
